import React from "react";

const Pagos = () => {
  return <div>Componente Pagos</div>;
};

export default Pagos;
